export enum LeftSidebarSection {
  DATA = "DATA",
  COMPUTE = "COMPUTE",
  SECURITY = "SECURITY",
}

export enum LeftSidebarDirectory {
  DATABASES = "DATABASES",
  ENGINES = "ENGINES",
  USERS = "USERS",
  ROLES = "ROLES",
  LOCATIONS = "LOCATIONS",
  SCRIPTS = "SCRIPTS",
  TEMP = "TEMP",
}
